// libraries
import { useEffect, useState } from 'react'
import { BrowserRouter, Switch, Route, RouteProps, useHistory } from 'react-router-dom'
import { notification } from 'antd'
import { useSetRecoilState } from 'recoil'

// navigation
import { AppHeader } from './header'
import { Sidebar } from './sidebar'
import { NotFoundRoute } from './not-found'

// locales
import { txt } from '../../locales/i18n'
import { queryMatchState } from '../../recoil/atoms'
import { Users } from '../shared/socket'

// routes
import { LoginRoute } from '../routes/login'

import { DashboardRoute } from '../routes/dashboards'
import { StatisticsRoute } from '../routes/dashboards/statistics'
import { StatisticsDenmarkRoute } from '../routes/dashboards/statistics/statistics-denmark'
import { StatisticsSwedenRoute } from '../routes/dashboards/statistics/statistics-sweden'
import { StatisticsGermanyRoute } from '../routes/dashboards/statistics/statistics-germany'
import { UserStoriesRoute } from '../routes/dashboards/user-stories'
import { ActivitiesRoute } from '../routes/dashboards/activities'
import { SubscriptionsRoute } from '../routes/dashboards/subscriptions'
import { SubscriptionsRevenueRoute } from '../routes/dashboards/subscriptions/subscriptions-revenue'
import { EventsRoute } from '../routes/dashboards/events'
import { OplevAltRoute } from '../routes/dashboards/oplevalt'
import { KrifaRoute } from '../routes/dashboards/krifa'

import { UserList } from '../routes/users/user-list/user-list'
import { UserImageList } from '../routes/users/image-list/user-image-list'
import { UserPage } from '../routes/users/user-page/user-page'
import { UserCreatePage } from '../routes/users/user-create-page/user-create-page'

import { PostPage } from '../routes/posts/post-page/post-page'
import { PostList } from '../routes/posts/post-list/post-list'

import { ActivityList } from '../routes/activities/activity-list/activity-list'
import { ActivityPage } from '../routes/activities/activity-page/activity-page'
import { CreateActivityPage } from '../routes/activities/activity-create-page/activity-create-page'

import { UnionList } from '../routes/unions/union-list/union-list'
import { UnionCreatePage } from '../routes/unions/union-create-page/union-create-page'
import { UnionPageRoute } from '../routes/unions/union-page/union-page'

import { GroupList } from '../routes/groups/group-list/group-list'
import { GroupPage } from '../routes/groups/group-page/group-page'
import { GroupCreatePage } from '../routes/groups/group-create-page/group-create-page'

import { ChristmasFriendTableRoute } from '../routes/christmas-friends/christmas-friend-table'

import { StoryTableRoute } from '../routes/stories/story-table'

import { ConversationRoute } from '../routes/conversations/conversation/conversation'

// import { SubjectTableRoute } from '../routes/subjects/subject-table/subject-table'
// import { CreateSubjectRoute } from '../routes/subjects/subject-create/subject-create'
// import { SubjectPageRoute } from '../routes/subjects/subject-page/subject-page'

import { WordTrackTable } from '../routes/word-track/word-track-list'
import { ReportList } from '../routes/report-list/report-list'

import { EventOverviewPage } from '../routes/events/overview/overview'
import { EventCreatePage } from '../routes/events/create'
import { EventPage } from '../routes/events/event'

import { RedCross } from '../routes/red-cross/red-cross'

import { Julevenner } from '../routes/dashboards/julevenner/julevenner'
import { NewYear } from '../routes/dashboards/new-year/new-year'
import { SwedenCounter } from '../routes/dashboards/sweden-counter/sweden-counter'

import { CmsOverviewRoute } from '../routes/cms/overview'
import { CmsPageRoute } from '../routes/cms/page'

import * as Oplevalt from '../routes/oplevalt/oplevalt'

import { AdvertisementsPage } from '../routes/advertisements/advertisements'
import { AdvertisementPage } from '../routes/advertisements/advertisement'

import * as Notifications from '../routes/notifications'
import { PressList } from '../routes/press/press'

export function Router(): JSX.Element {
	return (
		<BrowserRouter>
			<Switch>
				<Route exact path="/login" children={<LoginRoute />} />
				<PrivateRoute exact path="/" children={<></>} />

				<PrivateRoute exact path="/dashboards" children={<DashboardRoute />} dashboard />
				<PrivateRoute exact path="/dashboards/statistics" children={<StatisticsRoute />} dashboard />
				<PrivateRoute exact path="/dashboards/statistics-denmark" children={<StatisticsDenmarkRoute />} dashboard />
				<PrivateRoute exact path="/dashboards/statistics-sweden" children={<StatisticsSwedenRoute />} dashboard />
				<PrivateRoute exact path="/dashboards/statistics-germany" children={<StatisticsGermanyRoute />} dashboard />
				<PrivateRoute exact path="/dashboards/activities" children={<ActivitiesRoute />} dashboard />
				<PrivateRoute exact path="/dashboards/user-stories" children={<UserStoriesRoute />} dashboard />
				<PrivateRoute exact path="/dashboards/subscriptions" children={<SubscriptionsRoute />} dashboard />
				<PrivateRoute
					exact
					path="/dashboards/subscriptions-revenue"
					children={<SubscriptionsRevenueRoute />}
					dashboard
				/>
				<PrivateRoute exact path="/dashboards/events" children={<EventsRoute />} dashboard />
				<PrivateRoute exact path="/dashboards/oplevalt" children={<OplevAltRoute />} dashboard />
				<PrivateRoute exact path="/krifa" children={<KrifaRoute />} dashboard />

				<PrivateRoute exact path="/adduser" children={<UserCreatePage />} />
				<PrivateRoute exact path="/users" children={<UserList />} />
				<PrivateRoute exact path="/users/create" children={<UserCreatePage />} />
				<PrivateRoute exact path="/users/images" children={<UserImageList />} />
				<PrivateRoute exact path="/users/:id" children={<UserPage />} />
				<PrivateRoute exact path="/users/:userId/conversations/:id" children={<ConversationRoute />} />

				<PrivateRoute exact path="/posts" children={<PostList />} />
				<PrivateRoute exact path="/posts/:id" children={<PostPage />} />

				<PrivateRoute exact path="/unions" children={<UnionList />} />
				<PrivateRoute exact path="/unions/create" children={<UnionCreatePage />} />
				<PrivateRoute exact path="/unions/:id" children={<UnionPageRoute />} />

				<PrivateRoute exact path="/activities" children={<ActivityList />} />
				<PrivateRoute exact path="/activities/create" children={<CreateActivityPage />} />
				<PrivateRoute exact path="/activities/:id" children={<ActivityPage />} />

				<PrivateRoute exact path="/word-track" children={<WordTrackTable />} />
				<PrivateRoute exact path="/word-track/:id" children={<h1>word-track id</h1>} />

				<PrivateRoute exact path="/groups" children={<GroupList />} />
				<PrivateRoute exact path="/groups/create" children={<GroupCreatePage />} />
				<PrivateRoute exact path="/groups/:id" children={<GroupPage />} />

				<PrivateRoute exact path="/stories" children={<StoryTableRoute />} />
				<PrivateRoute exact path="/stories/:id" children={<h1>stories id</h1>} />

				<PrivateRoute exact path="/statistics" children={<h1>statistics table</h1>} />
				<PrivateRoute exact path="/statistics/:id" children={<h1>statistics id</h1>} />

				<PrivateRoute exact path="/christmas-friends" children={<ChristmasFriendTableRoute />} />
				<PrivateRoute exact path="/christmas-friends/:id" children={<h1>christmas-friends id</h1>} />

				<PrivateRoute exact path="/press" children={<PressList />} />

				{/* <PrivateRoute exact path="/subjects" children={<SubjectTableRoute />} />
				<PrivateRoute exact path="/subjects/create" children={<CreateSubjectRoute />} />
				<PrivateRoute exact path="/subjects/:id" children={<SubjectPageRoute />} /> */}

				<PrivateRoute exact path="/reports" children={<ReportList />} />

				<PrivateRoute exact path="/events" children={<EventOverviewPage />} />
				<PrivateRoute exact path="/events/create" children={<EventCreatePage />} />
				<PrivateRoute exact path="/events/:id" children={<EventPage />} />

				<PrivateRoute exact path="/red-cross" children={<RedCross />} />

				<Route exact path="/dashboards/julevenner" children={<Julevenner />} />
				<Route exact path="/dashboards/new-year" children={<NewYear />} />
				<Route exact path="/dashboards/sweden" children={<SwedenCounter />} />

				<PrivateRoute exact path="/cms" children={<CmsOverviewRoute />} />
				<PrivateRoute exact path="/cms/:pageId" children={<CmsPageRoute />} />

				<PrivateRoute exact path="/oplevalt" children={<Oplevalt.OplevAltPage />} />
				<PrivateRoute exact path="/oplevalt/experiences" children={<Oplevalt.ExperiencesPage />} />
				<PrivateRoute exact path="/oplevalt/experiences/:experienceId" children={<Oplevalt.ExperiencePage />} />

				<PrivateRoute exact path="/oplevalt/cms" children={<Oplevalt.CmsPages />} />
				<PrivateRoute exact path="/oplevalt/cms/:pageId" children={<Oplevalt.CmsPage />} />

				<PrivateRoute exact path="/advertisements" children={<AdvertisementsPage />} />
				<PrivateRoute exact path="/advertisements/:advertisementId" children={<AdvertisementPage />} />

				<PrivateRoute exact path="/notifications" children={<Notifications.Notifications />} />

				<PrivateRoute exact path="/notifications/:notificationId" children={<Notifications.Notification />} />

				<Route children={<NotFoundRoute />} />
			</Switch>

			<Users />
		</BrowserRouter>
	)
}

function PrivateRoute(props: RouteProps & { dashboard?: boolean }): JSX.Element {
	const [openMenu, setOpenMenu] = useState<boolean>(false)
	const setQueryMatch = useSetRecoilState(queryMatchState)
	const history = useHistory()
	const location = history.location

	useEffect(() => {
		function handleResize() {
			const windowHeight: number = window.innerHeight
			const computedStyles = getComputedStyle(document.documentElement)
			const safeAreaBottom = computedStyles.getPropertyValue('--sab')

			const root: HTMLElement | null = document.querySelector('#root')
			const sidebar: HTMLElement | null = document.querySelector('.sidebar-container')

			root?.style.setProperty('height', windowHeight - parseInt(safeAreaBottom) + 'px')
			sidebar?.style.setProperty('height', windowHeight - parseInt(safeAreaBottom) + 'px')
		}

		handleResize()
		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [history.location])

	useEffect(() => {
		async function handleAuthentication(): Promise<void> {
			const [route]: RegExpExecArray | [string] = /\/[\w-]*/i.exec(location.pathname) ?? ['']
			const authorizedRoutesStore: string = localStorage.getItem('bb_authorized_routes') ?? '[]'
			const authorizedRoutes: string[] = JSON.parse(authorizedRoutesStore)

			if (authorizedRoutes.length === 0) {
				history.replace('/login')
				return
			}

			if (location.pathname === '/') {
				if (authorizedRoutes.includes('*')) {
					history.replace('/users')
					return
				}

				const [entryRoute]: string[] = authorizedRoutes
				history.replace(entryRoute)
				return
			}

			if (authorizedRoutes.includes('*')) {
				return
			}

			if (authorizedRoutes.includes(route) === false) {
				const message: string = txt('navigation.error message')
				const description: string = txt('navigation.error description', { route })

				notification.error({ message, description })
				history.goBack()
			}
		}

		setQueryMatch(-1)
		handleAuthentication()
	}, [history, location, setQueryMatch])

	return (
		<Route {...props}>
			{Boolean(props.dashboard) === false && <AppHeader setOpenMenu={setOpenMenu} />}
			{Boolean(props.dashboard) === false && <Sidebar visible={openMenu} setVisible={setOpenMenu} />}
			{props.children}
		</Route>
	)
}
